import React from 'react';
import { FadeIn } from './FadeIn';
import { BookOpen, Gift, ArrowDown } from 'lucide-react';
export function OfferSection() {
  return <section className="py-10 sm:py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-130">
      <div className="max-w-4xl mx-auto" data-id="element-131">
        <FadeIn data-id="element-132">
          <div className="text-center mb-6 sm:mb-12" data-id="element-133">
            <h2 className="text-2xl sm:text-4xl font-bold text-charcoal mb-2 sm:mb-4" data-id="element-134">
              Lo que vas a recibir hoy mismo
            </h2>
            <div className="w-16 sm:w-24 h-1 bg-sage mx-auto rounded-full" data-id="element-135"></div>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-136">
          <div className="bg-cream rounded-2xl sm:rounded-3xl p-5 sm:p-12 shadow-lg border border-sage/20 flex flex-col md:flex-row gap-6 sm:gap-10 items-center" data-id="element-137">
            <div className="w-full md:w-1/2 relative" data-id="element-138">
              <div className="absolute -inset-4 bg-sage/10 rounded-full blur-2xl" data-id="element-139"></div>
              <img src="https://cdn.magicpatterns.com/uploads/msHtgY88YouBYucF16Fmu9/reinicioo_hormonass.png" alt="Ebook Reinicio Hormonal 40+" className="relative z-10 rounded-xl shadow-2xl w-full max-w-[200px] sm:max-w-sm mx-auto transform -rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-140" />
            </div>

            <div className="w-full md:w-1/2 space-y-3 sm:space-y-6" data-id="element-141">
              <div className="inline-flex items-center gap-2 bg-accent/10 text-accent px-3 sm:px-4 py-1.5 sm:py-2 rounded-full font-bold text-xs sm:text-sm" data-id="element-142">
                <Gift className="w-3.5 h-3.5 sm:w-4 sm:h-4" data-id="element-143" />
                ACCESO INMEDIATO
              </div>

              <h3 className="text-xl sm:text-3xl font-bold text-charcoal leading-tight" data-id="element-144">
                Ebook Principal <br data-id="element-145" />
                <span className="text-sage-dark italic font-serif" data-id="element-146">
                  "Reinicio Hormonal 40+"
                </span>
              </h3>

              <p className="text-sm sm:text-lg text-charcoal-light" data-id="element-147">
                Tu mapa paso a paso para los próximos 30 días. Diseñado para ser
                fácil de seguir, sin complicaciones y con resultados medibles
                desde la primera semana.
              </p>

              <div className="flex items-center gap-2 sm:gap-3 text-sage-dark font-medium bg-white p-3 sm:p-4 rounded-xl shadow-sm border border-cream-dark text-sm sm:text-base" data-id="element-148">
                <BookOpen className="w-5 h-5 sm:w-6 sm:h-6 flex-shrink-0" data-id="element-149" />
                <span data-id="element-150">
                  Formato Digital (PDF) - Lee en cualquier dispositivo
                </span>
              </div>

              <div className="text-right" data-id="element-151">
                <p className="text-xs sm:text-sm text-charcoal-light uppercase tracking-wider font-semibold" data-id="element-152">
                  Valor Real
                </p>
                <p className="text-xl sm:text-2xl font-bold text-charcoal/50 line-through decoration-accent decoration-2" data-id="element-153">
                  $14.99
                </p>
              </div>
            </div>
          </div>
        </FadeIn>

        <div className="mt-6 sm:mt-12 hidden sm:flex justify-center text-sage animate-bounce" data-id="element-154">
          <ArrowDown className="w-8 h-8" data-id="element-155" />
        </div>
      </div>
    </section>;
}